export default {
  // component: ActivityLog,
  component: load(() => import(/* webpackChunkName: "ActivityLog" */ "./Map")),
  priority: 2,
  permissions: ["MapConsoleMenu/MapDefinitionMenu"],
  name: app.translate("main.WorkShop"),
  icon: "content-paste",
  drawer: true,
  path: "WorkShop",
};
